import { render } from "./PaymentPolicy.vue?vue&type=template&id=356b3fcd"
import script from "./PaymentPolicy.vue?vue&type=script&lang=js"
export * from "./PaymentPolicy.vue?vue&type=script&lang=js"

import "./PaymentPolicy.vue?vue&type=style&index=0&id=356b3fcd&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__